import type { FC } from "react";

import { ChannelsOverviewBarChartContainer } from "app/pages/website-performance/components/ChannelsOverview/ChannelsOverviewBarChartContainer";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOChannelsOverviewBarChartContainerSI: FC<{ categoryBenchmark?: boolean; hideFooter?: boolean }> = ({
    categoryBenchmark,
    hideFooter = false,
}) => {
    const getCtaLink = (params) => {
        return {
            href: proNavigator.href("accountreview_website_marketingchannels", params),
            target: "_self",
        };
    };
    return (
        <ChannelsOverviewBarChartContainer
            getCtaLink={getCtaLink}
            categoryBenchmark={categoryBenchmark}
            unlockHook={{
                component: "WsWebTrafficChannels",
                hookModal: "WebTrafficChannelsFeature",
            }}
            hideFooter={hideFooter}
        />
    );
};
